// Décoration des segments renvoyés par le backend (id, label, color)
// avec les visuels locaux (image détourée, emoji de secours, couleur du texte).
// Mapping par mot-clé => robuste aux libellés configurés dans l'admin.

const ASSET = "/assets/roue";

const MAP = [
  { kw: ["jackpot", "menu"], short: "Jackpot", img: `${ASSET}/crown.png`, emoji: "👑" },
  { kw: ["bubble"], short: "Bubble Tea", img: `${ASSET}/bubble-tea.png`, emoji: "🧋" },
  { kw: ["crepe"], short: "Crêpe", img: `${ASSET}/crepe.png`, emoji: "🥞" },
  { kw: ["gaufre"], short: "Gaufre", img: `${ASSET}/gaufre.png`, emoji: "🧇" },
  { kw: ["milkshake"], short: "Milkshake", img: `${ASSET}/milkshake.png`, emoji: "🥤" },
  { kw: ["cocktail"], short: "Cocktail", img: `${ASSET}/cocktail.png`, emoji: "🍹" },
  { kw: ["boisson"], short: "Boisson", img: `${ASSET}/boisson.png`, emoji: "🥤" },
  { kw: ["topping"], short: "Topping", img: `${ASSET}/topping.png`, emoji: "✨" },
  { kw: ["burger"], short: "Burger", img: `${ASSET}/burger.png`, emoji: "🍔" },
  // Réduction : pas d'image, on dessine le "-XX%" en gros.
  { kw: ["%", "reduc", "remise", "discount"], short: "__percent__", img: "", emoji: "🏷️" },
];

const norm = (s) =>
  (s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");

// Luminance perçue -> texte sombre sur fond clair, blanc sinon.
const luminance = (hex) => {
  const c = (hex || "").replace("#", "");
  if (c.length < 6) return 0;
  const r = parseInt(c.slice(0, 2), 16);
  const g = parseInt(c.slice(2, 4), 16);
  const b = parseInt(c.slice(4, 6), 16);
  return (r * 299 + g * 587 + b * 114) / 1000;
};

// Version courte du libellé pour l'affichage sur la roue : on RESPECTE le texte
// saisi dans l'admin, on retire juste le superflu (suffixes « offert », etc.).
function cleanLabel(label) {
  let t = (label || "").trim();
  const pct = t.match(/-?\d+\s*%/);
  if (pct) return pct[0].replace(/\s/g, ""); // "-20% sur ta commande" -> "-20%"
  t = t.split(/\s[–—-]\s/)[0].trim();         // "Jackpot – Menu complet" -> "Jackpot"
  t = t.replace(/\s+(offerte?s?|gratuite?s?|au choix)$/i, "").trim();
  return t || (label || "Cadeau");
}

// Décoration d'un lot unique (grattage) à partir de son libellé.
export function decorateOne(label, icon) {
  const key = norm(label);
  const match = MAP.find((m) => m.kw.some((k) => key.includes(norm(k))));
  const custom = (icon || "").trim();
  return {
    label,
    short: cleanLabel(label),
    img: custom ? "" : match ? match.img : "",
    emoji: custom || (match ? match.emoji : "🎁"),
  };
}

export function decorateSegments(segments) {
  return (segments || []).map((s) => {
    const key = norm(s.label);
    const match = MAP.find((m) => m.kw.some((k) => key.includes(norm(k))));
    // Icône personnalisée (choisie dans l'admin) : on l'utilise telle quelle
    // et on n'affiche pas l'image auto.
    const custom = (s.icon || "").trim();
    return {
      id: s.id,
      label: cleanLabel(s.label),   // texte de l'admin respecté
      fullLabel: s.label,
      color: s.color || "#F26C1E",
      ink: luminance(s.color) > 160 ? "#1a1a1a" : "#ffffff",
      img: custom ? "" : match ? match.img : "",
      emoji: custom || (match ? match.emoji : "🎁"),
    };
  });
}
